import React from 'react';
import { compose } from '../../../utils/compose';
import { withAuthorization, withEmailVerification } from '../../../components/Session';
import { withFirebase } from '../../../components/Firebase';
import StudioEditorPage from '../StudioEditorPage';

const StudioEditorOnlyPageBase = ({ firebase }) => (
  <StudioEditorPage firebase={firebase} brandingContextLoading={false} mode="standalone" />
);

const condition = (authUser) => !!authUser;

export default compose(
  withFirebase,
  withEmailVerification,
  withAuthorization(condition),
)(StudioEditorOnlyPageBase);
